import { useEffect, useState } from 'react';
/** Returns `value` delayed by `ms` — updates only after the input settles. */
export function useDebouncedValue(value, ms = 300) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const t = setTimeout(() => setDebounced(value), ms);
        return () => clearTimeout(t);
    }, [value, ms]);
    return debounced;
}
